import styled from 'styled-components';

import { firefly, ripeLemon } from '@paradigm/design-system/src/colors';

import WarningBold from '@paradigm/design-system/src/assets/WarningBold';

const HedgeMarkWarning = styled.div.attrs({
  children: (
    <>
      <WarningBold height={14} />
      <span>Mark price for unhedged structure. Check ref price.</span>
    </>
  ),
})`
  display: flex;
  align-items: center;
  background: ${firefly};
  border-radius: 3px;
  border: 1px solid ${ripeLemon};
  padding: 6px 12px 8px;
  font-size: 13px;
  line-height: 16px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);

  > svg {
    margin-right: 0.5rem;
    color: ${ripeLemon};
  }
`;

export default HedgeMarkWarning;
